import React, { useState } from 'react';
import { IconButton, TextField, Chip, Box, FormControl, Autocomplete } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import CloseIcon from '@mui/icons-material/Close';
import { none, useHookstate, type State } from '@hookstate/core';
import ModalDrawMap from './Components/MapModal';
import { useLang } from '~/hooks/useLang';
import type { IGeographical } from './interfaces';
import { useMarkerState } from '../../stores/MapState';

interface FilterGeographicalAreaProps {
  readonly openModalGeographicalArea: State<boolean>
  readonly geographicalArea: State<IGeographical[]>
}

export default function FilterGeographicalArea({ openModalGeographicalArea, geographicalArea }: FilterGeographicalAreaProps) {
  const { translate } = useLang()

  const handleDeleteChip = (id: number) => {
    if (id) {
      const indexRemove = geographicalArea.get()?.findIndex(area => area.id == id) ?? null
      geographicalArea[indexRemove].set(none)
    }
  };

  const handleDeleteAll = () => {
    geographicalArea.set([])
  };

  return (
    <>
      <FormControl fullWidth size="small">
        <Autocomplete
          renderTags={(values, getTagProps, owner) => (
            <Box sx={{ width: '70%' }}>
              {values.map((value) => {
                return (
                  <Chip
                    key={value?.id}
                    label={owner.getOptionLabel(value)}
                    size={owner.size}
                    sx={{
                      margin: '4px',
                      backgroundColor: value?.color,
                    }}
                    onDelete={() => handleDeleteChip(value?.id)}
                    // {...getTagProps({ index })}
                    {...owner.ChipProps}
                  />
                )
              })}
            </Box>
          )}
          ListboxProps={{ style: { maxHeight: '15rem' } }}
          id="filter-types"
          multiple
          readOnly
          popupIcon={null}
          options={[]}
          value={geographicalArea.get()}
          filterSelectedOptions
          noOptionsText={translate('No options')}
          clearText={translate('Clear')}
          size="small"
          disableCloseOnSelect
          disableClearable
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          getOptionLabel={(option) => option?.name ?? option?.name ?? ''}
          onChange={(_, areas) => ''}
          renderInput={(params) => (
            <TextField
              {...params}
              label={translate('Geographical Area')}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginRight: '-25px', width: '20%', gap: 1 }}>
                    {geographicalArea.get().length > 0 && (
                      <IconButton
                        aria-label="clear-all-geographical-areas"
                        onClick={handleDeleteAll}
                        edge="end"
                        size="small"
                        sx={{ padding: '0px' }}
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                    <IconButton
                      aria-label="filter-geographical-area"
                      onClick={() => openModalGeographicalArea.set(true)}
                      size="small"
                      sx={{ padding: '0px' }}
                      edge="end"
                    >
                      <PublicIcon />
                    </IconButton>
                    {params.InputProps.endAdornment}
                  </Box>
                ),
              }}
            />
          )}
        />
      </FormControl>

      <ModalDrawMap
        isOpen={openModalGeographicalArea}
        geographicalArea={geographicalArea}
      />
    </>
  )
}